import { useEffect, useState } from 'react';
import { Bars } from 'react-loader-spinner';
import { ToggleWithLabel } from '../ToggleWithLabel';
import { useDirectorsAndShareholders } from '../../../../../hooks/useDirectorsAndShareholders';
import { MainCustomButton } from '../../../../../components/Buttons';
import { CustomTooltip } from '../../../../../components/atoms';
import { useTranslation } from 'react-i18next';
import { JurisdictionSelect } from '../JurisdictionSelect';

interface InputItem {
  id: string;
  label: string;
  value: string;
  active: boolean;
}

const DirectorsAndShareholdersTab = () => {
  const { values, loading, updateConfigs } = useDirectorsAndShareholders();
  const [items, setItems] = useState<InputItem[]>([]);
  const [selectedJurisdictionId, setSelectedJurisdictionId] = useState<number | null>(null);
  const { t } = useTranslation();

  const handleSave = async () => {
    const payload = items.reduce((acc, item) => {
      return { ...acc, [item.id]: Number(item.value) };
    }, {} as any);
    payload.config_id = values?.config_id

    await updateConfigs(payload);
  };

  useEffect(() => {
    if (values) {
      setItems([
        {
          id: 'directors_value',
          label: t('config.DirectorFee'),
          value: values.directors_value.toString(),
          active: true
        },
        {
          id: 'corporate_director_value',
          label: t('config.CorporateDirectorFee'),
          value: values.corporate_director_value.toString(),
          active: true
        },
        {
          id: 'shareholders_value',
          label: t('config.ShareholdersFee'),
          value: values.shareholders_value.toString(),
          active: true
        }
      ]);
    }
  }, [values]);

  const updateValue = (id: string, newValue: string) => {
    setItems(prev =>
      prev.map(item => (item.id === id ? { ...item, value: newValue } : item))
    );
  };

  const toggleActive = (id: string) => {
    setItems(prev =>
      prev.map(item => (item.id === id ? { ...item, active: !item.active } : item))
    );
  };

  if (loading)
    return (
      <div className="flex items-center justify-center py-6">
        <Bars height="32" width="32" color="#4B5563" />
      </div>
    );

  return (
    <div className="flex flex-col gap-4">
      <JurisdictionSelect
        selectedJurisdictionId={selectedJurisdictionId}
        setSelectedJurisdictionId={setSelectedJurisdictionId}
      />

      {items.map((item) => {
        const tooltipKey =
          item.id === 'directors_value'
            ? 'config.tooltipDirectorFee'
            : item.id === 'corporate_director_value'
              ? 'config.tooltipCorporateDirectorFee'
              : 'config.tooltipShareholdersFee';
        return (
        <div
          key={item.id}
          className="border border-dashed p-4 rounded flex items-center justify-between"
        >
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <label className="text-sm">{item.label}:</label>
              <CustomTooltip content={t(tooltipKey)} />
            </div>
            {/* <input
              type="text"
              value={item.value}
              onChange={(e) => updateValue(item.id, e.target.value)}
              className="mt-1 border rounded px-3 py-1 w-40"
            /> */}
            <div className="relative mt-1 w-40">
              <span className="absolute left-3 inset-y-0 flex items-center pointer-events-none">$</span>
              <input
                type="text"
                value={item.value}
                onChange={(e) => updateValue(item.id, e.target.value)}
                className="pl-7 pr-2 py-1.5 border rounded w-full"
              />
            </div>

            
          </div>
          <ToggleWithLabel
            checked={item.active}
            onChange={() => toggleActive(item.id)}
          />
        </div>
        );
      })}
      <MainCustomButton text={t('others.othSave')} onClick={handleSave} />
    </div>
  );
};

export { DirectorsAndShareholdersTab };